import React, { useEffect, useRef, useState } from "react";
import { Table, Button } from "react-bootstrap";
import Layout from "../../../components/Layout";
import { useNavigate } from "react-router-dom";
import { MdModeEdit, MdDelete } from "react-icons/md";
import ToastFile from "../../../utils/ToastFile";
import {
  addTaskLog,
  deleteTaskLogByID,
  getAllDailyTaskLogbyEmployee,
  getAllTaskbyContractor,
} from "../../../api/TaskApi";
import { FaEye, FaPlay, FaRegStopCircle } from "react-icons/fa";
import moment from "moment";
import { TaskStatusEnum } from "../../../config/staticArray";
import { getAllRoutebyContractor } from "../../../api/RouteApi";
import "./MyTasks.css";
import DeleteModel from "../../../components/DeleteModel";
import Loader from "../../../components/Loader";
import { formatHours } from "../../../utils/utility";

const MyTask = () => {
  const [tasks, setTasks] = useState([]);
  const [taskLogs, setTaskLogs] = useState([]);
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [routeOptions, setRouteOptions] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [isLoading, setIsloading] = useState({
    isTask: true,
    isTaskLog: true,
  });

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getTask();
    getTaskLog();
    getRoute();
  }, []);

  const getTask = () => {
    setIsloading((prev) => ({ ...prev, isTask: true }));
    getAllTaskbyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setTasks(res?.data?.data?.tasks);
        } else {
          ToastFile("Failed to fetch tasks", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tasks:", err);
        ToastFile("Error fetching tasks", "error");
      })
      .finally(() => {
        setIsloading((prev) => ({ ...prev, isTask: false }));
      });
  };

  const getTaskLog = () => {
    setIsloading((prev) => ({ ...prev, isTaskLog: true }));
    const Today = moment(new Date()).format("YYYY-MM-DD");
    getAllDailyTaskLogbyEmployee(user.id, Today)
      .then((res) => {
        if (res.status === 200) {
          setTaskLogs(res?.data?.data?.taskLogs);
        } else {
          ToastFile("Failed to fetch tasks", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tasks:", err);
        ToastFile("Error fetching tasks", "error");
      })
      .finally(() => {
        setIsloading((prev) => ({ ...prev, isTaskLog: false }));
      });
  };

  const deleteTaskLog = () => {
    deleteTaskLogByID(deleteIndex)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Task deleted", "deleted");
          fetched.current = false;
          getTaskLog();
          getTask();
        } else {
          ToastFile("Failed to delete task", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting task:", err);
        ToastFile("Error deleting task", "error");
      })
      .finally(() => {
        setDeleteIndex(0);
        setDeleteModal(false);
      });
  };

  const openViewModal = (index) => {
    const taskLog = taskLogs[index];
    taskLog.date = moment(taskLog.date).format("YYYY-MM-DD");
    taskLog.startTime = moment(taskLog.startTime).format("HH:mm");
    taskLog.endTime = moment(taskLog.endTime).format("HH:mm");
    navigate("/mytask/view", {
      replace: true,
      state: { taskLog, mode: "View",from:"task" },
    });
  };

  const openEditModal = (_id) => {
    let taskLog = taskLogs.find((el) => el._id === _id);
    taskLog.status = TaskStatusEnum.COMPLETED;
    taskLog.date = moment(taskLog.date).format("YYYY-MM-DD");
    taskLog.startTime = moment(taskLog.startTime).format("HH:mm");
    taskLog.endTime = moment(new Date()).format("HH:mm");
    navigate("/mytask/edit", {
      replace: true,
      state: { taskLog, mode: "Edit",from:"task" },
    });
  };

  const openStartModal = (id) => {
    let task = tasks[id];
    let taskLog = {
      task_id: task._id,
      employee: user.id,
      category: task.category,
      description: task.description,
      workType: task.workType,
      date: moment(new Date()).format("YYYY-MM-DD"),
      startTime: new Date(),
      endTime: null,
      actualHours: task.estimationHours,
      status: TaskStatusEnum.IN_PROGRESS,
      tenant_id: task.tenant_id,
      fuelCost: "0",
      claimHours: "",
      createdBy: user.user_id,
      createdAt: new Date(),
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    navigate("/mytask/start", {
      replace: true,
      state: { taskLog, mode: "Start",from:"task" },
    });
  };

  const getRoute = () => {
    getAllRoutebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setRouteOptions(res?.data?.data?.routes);
        } else {
          ToastFile("Failed to fetch routes", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching routes:", err);
        ToastFile("Error fetching routes", "error");
      });
  };

  return (
    <Layout>
      <DeleteModel
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onYes={deleteTaskLog}
      />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
       Daily's Task
          </span>
      </div>
      {/* Card layout for mobile, table for desktop */}
      <div className="tasks-table d-none d-md-block">
        <Table striped bordered hover responsive>
          <thead className="table-dark">
            <tr>
              <th>Category</th>
              <th style={{ textAlign: "center" }}>Actions</th>
            </tr>
          </thead>
          {isLoading.isTask ? (
            <tbody>
              <tr>
                <td colSpan="6">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {tasks.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No task found
                  </td>
                </tr>
              ) : (
                tasks.map((c, idx) => (
                  <tr key={idx}>
                    <td>{c.category}</td>
                    <td style={{ textAlign: "center" }}>
                      <span
                        className="me-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => openStartModal(idx)}
                      >
                        <FaPlay size={17} />
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          )}
        </Table>
      </div>
      {isLoading.isTask ? (
        <div className="tasks-cards d-block d-md-none">
          <Loader />
        </div>
      ) : (
        <div className="tasks-cards d-block d-md-none">
          {tasks.length === 0 ? (
            <div className="card-empty">No task found</div>
          ) : (
            tasks.map((c, idx) => (
              <div
                className="task-card d-flex justify-content-between align-items-center"
                key={idx}
              >
                <div className="task-card-header">{c.category}</div>
                <div className="task-card-actions">
                  <span
                    className="me-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => openStartModal(idx)}
                  >
                    <FaPlay size={24} />
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      )}
      {/* Task In Progress */}
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <h3 className="mb-0">Task In Progress</h3>
      </div>
      <div className="tasks-table d-none d-md-block">
        <Table striped bordered hover responsive>
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th>Category</th>
              <th>Route Name</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          {isLoading.isTaskLog ? (
            <tbody>
              <tr>
                <td colSpan="8">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {taskLogs.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No task found
                  </td>
                </tr>
              ) : (
                taskLogs
                  .filter((el) => el.status === TaskStatusEnum.IN_PROGRESS)
                  .map((c, idx) => (
                    <tr key={idx}>
                      <td>{c.category}</td>
                      <td>
                        {c.routeInfo.map((item, index) => {
                          const matched = routeOptions.find(
                            (el) => el._id === item
                          );
                          return (
                            <span key={index}>
                              {matched?.routeName}
                              {index < c.routeInfo.length - 1 ? ", " : ""}
                            </span>
                          );
                        })}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {moment(c.date).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {moment(c.startTime).format("hh:mm A")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {c.status === TaskStatusEnum.IN_PROGRESS && (
                          <span className="badge bg-warning">{c.status}</span>
                        )}
                        {c.status === TaskStatusEnum.COMPLETED && (
                          <span className="badge bg-success">{c.status}</span>
                        )}
                        {c.status === TaskStatusEnum.CANCELLED && (
                          <span className="badge bg-danger">{c.status}</span>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          className="me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => openEditModal(c._id)}
                        >
                          <FaRegStopCircle size={20} />
                        </span>
                        <span
                          className="me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setDeleteIndex(c._id);
                            setDeleteModal(true);
                          }}
                        >
                          <MdDelete size={20} />
                        </span>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          )}
        </Table>
      </div>
      {isLoading.isTaskLog ? <div className="tasks-cards d-block d-md-none">
          <Loader />
        </div> : 
      <div className="tasks-cards d-block d-md-none">
        {taskLogs.filter((el) => el.status === TaskStatusEnum.IN_PROGRESS)
          .length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No task found</p>
          </div>
        ) : (
          <div className="row g-3">
            {taskLogs
              .filter((el) => el.status === TaskStatusEnum.IN_PROGRESS)
              .map((c, idx) => (
                <div key={idx} className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="flex-grow-1">
                          <h6 className="card-title mb-1">{c.category}</h6>
                          <small className="text-muted d-block">
                            {moment(c.date).format("DD-MM-YYYY")}
                          </small>
                        </div>
                        <div className="text-end">
                          <div className="mb-2">
                            {c.status === TaskStatusEnum.IN_PROGRESS && (
                              <span className="badge bg-warning">
                                {c.status}
                              </span>
                            )}
                            {c.status === TaskStatusEnum.COMPLETED && (
                              <span className="badge bg-success">
                                {c.status}
                              </span>
                            )}
                            {c.status === TaskStatusEnum.CANCELLED && (
                              <span className="badge bg-danger">
                                {c.status}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row g-2 mb-3">
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Start Time
                          </small>
                          <span>{moment(c.startTime).format("hh:mm A")}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">Route</small>
                          <span className="small">
                            {c.routeInfo.map((item, index) => {
                              const matched = routeOptions.find(
                                (el) => el._id === item
                              );
                              return (
                                <span key={index}>
                                  {matched?.routeName}
                                  {index < c.routeInfo.length - 1 ? ", " : ""}
                                </span>
                              );
                            })}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex gap-3">
                        <span
                          className="me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => openEditModal(c._id)}
                        >
                          <FaRegStopCircle size={24} /> Stop
                        </span>
                        <span
                          className="me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setDeleteIndex(c._id);
                            setDeleteModal(true);
                          }}
                        >
                          <MdDelete size={24} /> Delete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div> }
      {/* Task Finished */}
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <h3 className="mb-0">Task Finished</h3>
      </div>
      <div className="tasks-table d-none d-md-block">
        <Table striped bordered hover responsive>
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th>Category</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Actual working hours</th>
              <th>Claim hours / No of Parcels</th>
              <th>Pay Rate / Per Parcel Cost</th>
              <th>Fuel Cost</th>
              <th>Total Cost</th>
              <th>Status</th>
              <th>Approved</th>
              <th>Actions</th>
            </tr>
          </thead>
          {isLoading.isTaskLog ? (
            <tbody>
              <tr>
                <td colSpan="12">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {taskLogs.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center">
                    No task found
                  </td>
                </tr>
              ) : (
                taskLogs
                  .filter((el) => el.status === TaskStatusEnum.COMPLETED)
                  .map((c, idx) => (
                    <tr key={idx}>
                      <td>{c.category}</td>
                      <td style={{ textAlign: "center" }}>
                        {moment(c.date).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {moment(c.startTime).format("hh:mm A")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {moment(c.endTime).format("hh:mm A")}
                      </td>
                      <td style={{ textAlign: "end" }}>{(c.actualHours == 0 || parseInt(c.actualHours.split(':')[0]) > 15) ? 'N/A': formatHours(c.actualHours)}</td>
                      <td style={{ textAlign: "end" }}>{c.claimHours}</td>
                      <td style={{ textAlign: "end" }}>{c.payrate}</td>
                      <td style={{ textAlign: "end" }}>{c.fuelCost}</td>
                      <td style={{ textAlign: "end" }}>{c.totalCost}</td>
                      <td style={{ textAlign: "center" }}>
                        {c.status === TaskStatusEnum.IN_PROGRESS && (
                          <span className="badge bg-warning">{c.status}</span>
                        )}
                        {c.status === TaskStatusEnum.COMPLETED && (
                          <span className="badge bg-success">{c.status}</span>
                        )}
                        {c.status === TaskStatusEnum.CANCELLED && (
                          <span className="badge bg-danger">{c.status}</span>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {c.isApproved === "Yes"
                          ? "Yes"
                          : c.isApproved === "No"
                          ? "Rejected"
                          : "No"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          className="me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => openViewModal(idx)}
                        >
                          <FaEye size={20} />
                        </span>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          )}
        </Table>
      </div>
      {isLoading.isTaskLog ? <div className="tasks-cards d-block d-md-none">
          <Loader />
        </div> :
      <div className="tasks-cards d-block d-md-none">
        {taskLogs.filter((el) => el.status === TaskStatusEnum.COMPLETED)
          .length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No task found</p>
          </div>
        ) : (
          <div className="row g-3">
            {taskLogs
              .filter((el) => el.status === TaskStatusEnum.COMPLETED)
              .map((c, idx) => (
                <div key={idx} className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="flex-grow-1">
                          <h6 className="card-title mb-1">{c.category}</h6>
                          <small className="text-muted d-block">
                            {moment(c.date).format("DD-MM-YYYY")}
                          </small>
                        </div>
                        <div className="text-end">
                          <div className="mb-2">
                            {c.status === TaskStatusEnum.IN_PROGRESS && (
                              <span className="badge bg-warning">
                                {c.status}
                              </span>
                            )}
                            {c.status === TaskStatusEnum.COMPLETED && (
                              <span className="badge bg-success">
                                {c.status}
                              </span>
                            )}
                            {c.status === TaskStatusEnum.CANCELLED && (
                              <span className="badge bg-danger">
                                {c.status}
                              </span>
                            )}
                          </div>
                          <div>
                            {c.isApproved === "Yes" ? (
                              <span className="badge bg-success">Approved</span>
                            ) : c.isApproved === "No" ? (
                              <span className="badge bg-danger">Rejected</span>
                            ) : (
                              <span className="badge bg-secondary">
                                Pending
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row g-2 mb-3">
                         {c.routeInfo && c.routeInfo.length > 0 && (
                        <div className="mb-2">
                          <small className="text-muted d-block">Route</small>
                          <span className="small">
                            {c.routeInfo.map((item, index) => {
                              const matched = routeOptions.find(
                                (el) => el._id === item
                              );
                              return (
                                <span key={index}>
                                  {matched?.routeName}
                                  {index < c.routeInfo.length - 1 ? ", " : ""}
                                </span>
                              );
                            })}
                          </span>
                        </div>
                      )}
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Start Time
                          </small>
                          <span>{moment(c.startTime).format("hh:mm A")}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">End Time</small>
                          <span>{moment(c.endTime).format("hh:mm A")}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Actual working hours
                          </small>
                          <span> {(c.actualHours == 0 || parseInt(c.actualHours.split(':')[0]) > 15) ? 'N/A': formatHours(c.actualHours)}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Claim hours / No of Parcels
                          </small>
                          <span>{c.claimHours}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Pay Rate / Per Parcel Cost
                          </small>
                          <span>${c.payrate}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Fuel Cost
                          </small>
                          <span>${c.fuelCost}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">
                            Total Cost
                          </small>
                          <span>${c.totalCost}</span>
                        </div>
                      </div>
                     
                      <div className="d-flex gap-3">
                        <span
                          className="me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => openViewModal(idx)}
                        >
                          <FaEye size={24} /> View
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div> }
    </Layout>
  );
};

export default MyTask;
